import { Block, Flex, Typography, theme } from '@aloft/toolkit-sui';

import {
  RECOMMENDED_COMPS_STATUS_GROUP_LABELS,
  RecommendedCompsStatusGroup,
} from '../../utils/getStatusGroup.ts';
import { StatusGroupPinIcon } from './StatusGroupPinIcon.tsx';

const StatusGroupExpandIcon = ({ collapsed }: { collapsed: boolean }) => (
  <svg
    width="16"
    height="16"
    viewBox="0 0 16 16"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    style={{
      display: 'block',
      flexShrink: 0,
      transition: 'transform 0.2s ease',
      transform: collapsed ? 'rotate(-90deg)' : 'rotate(0deg)',
    }}
  >
    <path
      d="M10.7772 6C11.0011 6 11.2042 6.16245 11.291 6.41236C11.3778 6.66228 11.3292 6.9476 11.1712 7.1392L8.39371 10.4714C8.17672 10.7317 7.82432 10.7317 7.60732 10.4714L4.82979 7.1392C4.67008 6.9476 4.62321 6.66228 4.71001 6.41236C4.7968 6.16245 4.99817 6 5.22211 6H10.7772Z"
      fill={theme.colors.textLight}
    />
  </svg>
);

export const StatusGroupHeaderRow = ({
  groupId,
  count,
  collapsed,
  colSpan,
  onToggle,
}: {
  groupId: RecommendedCompsStatusGroup;
  count: number;
  collapsed: boolean;
  colSpan: number;
  onToggle: () => void;
}) => (
  <tr>
    <td
      colSpan={colSpan}
      style={{
        padding: 0,
        backgroundColor: theme.colors.surface2,
        borderTop: `1px solid ${theme.colors.strokeDefault}`,
        borderBottom: `1px solid ${theme.colors.strokeDefault}`,
      }}
    >
      <Flex
        alignItems="center"
        gap="8px"
        padding="12px 16px"
        __dangerDoNotUseSx={{
          cursor: 'pointer',
          userSelect: 'none',
          transition: 'background-color 0.15s ease',
          _hover: { backgroundColor: theme.colors.hoverTransparentLight },
        }}
        onClick={onToggle}
      >
        <StatusGroupExpandIcon collapsed={collapsed} />
        <StatusGroupPinIcon variant={groupId} />
        <Typography variant="body2" __dangerDoNotUseSx={{ fontWeight: 600 }}>
          {RECOMMENDED_COMPS_STATUS_GROUP_LABELS[groupId]}
        </Typography>
        <Typography variant="body2" color="textSecondary">
          ({count})
        </Typography>
        <Block flex={1} />
      </Flex>
    </td>
  </tr>
);
